/* eslint-disable import/prefer-default-export */
import { CUSTOM_SCHEDULE } from '../../../edit-listing/config/listing';
import { getNonCustomSession } from './getNonCustomSession';
import { getCustomSession } from './getCustomSession';

export const getSession = ({
  isRecurring,
  firstSession,
  recurringOption,
  numberOfSessions,
  endDate = null,
  endOption = 'after-sessions',
  availabilityPlan,
  firstDayOfWeek,
  startTime,
  endTime,
  exceptions,
  blockBooking,
  includePast,
}) => {
  if (isRecurring === 'no' || !isRecurring || !startTime || !endTime) return [];

  if (recurringOption !== CUSTOM_SCHEDULE) {
    return getNonCustomSession({
      isRecurring,
      firstSession,
      recurringOption,
      numberOfSessions,
      endDate,
      endOption,
      startTime,
      endTime,
      exceptions,
      blockBooking,
    });
  }
  return getCustomSession({
    firstSession,
    numberOfSessions,
    endDate,
    endOption,
    availabilityPlan,
    firstDayOfWeek,
    blockBooking,
    includePast,
  });
};
